import { render, staticRenderFns } from "./AdaugaProgramare_dialog.vue?vue&type=template&id=c819b80a&scoped=true"
import script from "./AdaugaProgramare_dialog.vue?vue&type=script&lang=js"
export * from "./AdaugaProgramare_dialog.vue?vue&type=script&lang=js"
import style0 from "./AdaugaProgramare_dialog.vue?vue&type=style&index=0&id=c819b80a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c819b80a",
  null
  
)

export default component.exports